import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FullDetailedPaymentInfo } from '@core/models/detailed-payment-info.model';
import { PrizeDelivery } from '@core/models/prize-delivery.model';
import {
  Raffle,
  SimpleRaffleAvailableGroup,
  TicketsCount
} from '@core/models/raffle.model';
import { API_LIST } from '@core/services/web-api/api-list';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RaffleService {
  constructor(private httpClient: HttpClient) {}

  getSimpleRaffleGroupsInstantWin(
    slug: string
  ): Observable<SimpleRaffleAvailableGroup> {
    return this.httpClient.get<SimpleRaffleAvailableGroup>(
      API_LIST.getSimpleRaffleGroupsInstantWin(slug)
    );
  }

  getGameBySlug(
    slug: string,
    currency: string,
    cartId?: string,
    includeFinished?: boolean
  ): Observable<Raffle> {
    return this.httpClient.get<Raffle>(
      API_LIST.getGameBySlug(slug, currency, cartId, includeFinished)
    );
  }

  getPrizeDeliveryLinkDashboard(slug: string): Observable<PrizeDelivery> {
    return this.httpClient.get<PrizeDelivery>(
      API_LIST.getPrizeDeliveryLinkDashboard(slug)
    );
  }

  getPrizeDeliveryLink(
    orderId: string,
    queryKey: string
  ): Observable<PrizeDelivery> {
    return this.httpClient.get<PrizeDelivery>(
      API_LIST.getPrizeDeliveryLink(orderId, queryKey)
    );
  }

  getUserOrderDetailedPayment(
    orderId: string,
    queryKey: string
  ): Observable<FullDetailedPaymentInfo> {
    return this.httpClient.get<FullDetailedPaymentInfo>(
      API_LIST.getUserOrderDetailedPayment(orderId, queryKey)
    );
  }

  getUserGameTicketsCount(slug: string): Observable<TicketsCount> {
    return this.httpClient.get<TicketsCount>(
      API_LIST.getUserGameTicketsCount(slug)
    );
  }
}
